import {Component,Input,Output,EventEmitter,ViewChild, OnInit} from '@angular/core';
@Component({
    selector:'grey-header',
    templateUrl:'app.grey.header.html'
})
export class GreyHeaderComponent implements OnInit
{
    @Input() GreySectionDetails: any;
    @Input() GreyTestInfo: any;   
    public TestInfo:any;
    public SectionDetailsList:any;
    ngOnInit(){
        this.TestInfo=this.GreyTestInfo;
        this.SectionDetailsList=this.GreySectionDetails;
    }
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/Headers/Themes/Grey/app.grey.ts